<script
  lang="ts"
  setup
>
import {
  computed,
  defineAsyncComponent,
  ref,
  watch,
} from '#imports'
import { type ActivityType } from '~/api'
import { useLayout } from '~/store/layout'
import $track from '~/track/webOfficialWebsite'

const AsyncScrollLoadingAnimation = defineAsyncComponent(() => import('~/components/LottieAnimation.vue'))
const lottieData = async () => (await import('@/assets/images/activity/activity-enter-xmas.json')).default
const props = defineProps<{
  activity: ActivityType
}>()
const isMobile = computed(() => useLayout().isMobile)
const visible = ref<boolean>(false)
// 展开活动
const onClick = () => {
  // visible.value = true
  if (!props.activity?.deepLink) return
  if (props.activity?.deepLink?.includes('_blank')) {
    window.open(props.activity?.deepLink)
  } else {
    window.location.href = props.activity?.deepLink
  }
  $track.web_official_activity_banner_click({ template: 'CHRISTMAS' })
}

watch(visible, (val: boolean) => {
  if (val) {
    $track.web_official_activity_pop_show({ template: 'CHRISTMAS', pop_rank: 0 })
  }
})

</script>

<template>
  <div
    v-if="isMobile && visible"
    class="mask"
  />

  <div
    v-if="!visible && activity?.deepLink && activity?.image"
    :class="isMobile ? 'mobile-activity-animation' : 'activity-animation'"
    @click="onClick"
  >
    <img
      :src="activity?.image"
      alt="activity"
    >
  </div>
  <AsyncScrollLoadingAnimation
    v-else-if="!visible && activity?.deepLink"
    :animation-data="lottieData"
    :class="isMobile ? 'mobile-activity-animation' : 'activity-animation'"
    autoplay
    @click="onClick"
  />
</template>

<style
  lang="less"
  scoped
>
.activity-animation {
  position: fixed;
  z-index: 9999;
  right: 46px;
  bottom: 46px;
  width: 110px;
  cursor: pointer;
}

.mobile-activity-animation {
  position: fixed;
  z-index: 998;
  right: 20px;
  bottom: 20px;
  width: 84px;
}

/*
  进入和离开动画可以使用不同
  持续时间和速度曲线。
*/
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.fade-in-bottom-enter-active {
  transition: all 0.5s ease-out;
}

.fade-in-bottom-leave-active {
  transition: all 0.5s ease-out;
}

.fade-in-bottom-enter-from,
.fade-in-bottom-leave-to {
  //transform: translate(20px,160px);
  opacity: 0;
}

img {
  width: 100%;
  height: 100%;
}

.activity {
  position: fixed;
  z-index: 9999;
  right: 46px;
  border-radius: 16px;
  overflow: hidden;
  bottom: 46px;
  width: 388px;
  /* background-color: #fff; */
  filter: drop-shadow(0px 4px 24px rgba(134, 163, 184, 0.32));

  &__banner {
    width: 100%;
    background-color: #fff;
  }

  .groups {
    padding: 24px 16px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    gap: 12px;
    border-radius: 0 0 16px 16px;

    .group-item {
      display: flex;
      border-radius: 8px;
      align-items: center;
      cursor: pointer;

      padding: 13px;

      span {
        font-size: 16px;
        line-height: 22px;
        color: #fff;
        margin-left: 16px;
      }

      &__icon {
        height: 24px;
        width: 24px;
        flex-shrink: 0;
      }

      &:hover {
        background-color: var(--hover-color) !important;
      }
    }
  }

  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    z-index: 999;
    cursor: pointer;
  }

}

.mobile-activity {
  position: fixed;
  right: calc(50vw - 160px) !important;
  top: calc(50vh - 200px) !important;
  width: 320px;
  bottom: auto;
}

:deep(.el-carousel__arrow) {
  background-color: rgba(0, 0, 0, 0.2);
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 9998;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.6);
}
</style>
